import { ComponentType, SVGProps, useMemo } from "react";
import {
  Avatar as NextUIAvatar,
  AvatarProps as NextUIAvatarProps,
} from "@heroui/react";
import { User } from "assets/icons";

const backgroundColors = [
  "#EC8077", // tag-red
  "#F19B68", // tag-orange
  "#F8D45D", // tag-yellow
  "#364FF3", // tag-indigo
  "#61C9DF", // tag-skyBlue
  "#6FC676", // tag-green
  "#B9E369", // tag-lime
  "#AA5CE3", // tag-violet
  "#EC7AD9", // tag-pink
];

export interface AvatarProps extends NextUIAvatarProps {
  FallbackIcon?: ComponentType<SVGProps<SVGSVGElement>>;
  sizing?: string;
}

export const Avatar = ({
  src,
  FallbackIcon = User,
  sizing = "h-14 w-14",
}: AvatarProps) => {
  const randomBackgroundColor = useMemo(() => {
    return backgroundColors[
      Math.floor(Math.random() * backgroundColors.length)
    ];
  }, [src]); // Adding src as a dependency

  const avatarStyle = src ? {} : { backgroundColor: randomBackgroundColor };

  return (
    <NextUIAvatar
      src={src}
      className={`${sizing}`}
      style={avatarStyle}
      showFallback
      fallback={<FallbackIcon className="h-full w-full text-white" />}
    />
  );
};
